import { LiveData } from '@toeverything/infra';

import type { Citation } from '../orchestration/types';

/**
 * The citation currently shown in the docked side panel, or null when closed.
 * Module scope so the opener (anywhere) and the panel (in the workbench layout)
 * share one source of truth without DI plumbing. A side panel — not a workbench
 * split pane — is used because the web browser-router adapter clobbers any
 * split pane's route to the current URL; and not a modal, so the doc stays
 * visible beside it (no context switch).
 */
export const activeCitation$ = new LiveData<Citation | null>(null);

export function openCitationPanel(citation: Citation): void {
  activeCitation$.next(citation);
}

export function closeCitationPanel(): void {
  activeCitation$.next(null);
}
